import React, { FC } from "react";
import "./index.scss";
import { Translate } from "react-redux-i18n";

interface SurveyTemplateButtonProps {
  title: string;
  onClick: () => void;
}

const SurveyTemplateButton: FC<SurveyTemplateButtonProps> = ({ title, onClick }) => {
  return (
    <button className="survey-template-button" onClick={onClick}>
      <Translate value={title} />
    </button>
  );
};

export default SurveyTemplateButton;
